/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2022-12-14 09:59:19
 * @LastEditors: ywj@originqc.com
 * @LastEditTime: 2025-04-29 11:17:48
 * @FilePath: \qcloud-web-pc-4.0\src\router\lang\cn.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const documentTitle = {
  home: '首页_本源量子云',
  qhComputing: '量-超-云融合_本源量子云',
  user_knowledge: '初次接触_本源量子云',
  user_student: '学生_本源量子云',
  user_company: '企业_本源量子云',
  user_developer: '开发人员_本源量子云',
  user_educator: '教育工作者_本源量子云',
  quantumVm_introduce: '逻辑门介绍_本源量子云',
  quantumVm: '图形化编程_工作台_本源量子云',
  services: '计算服务_工作台_本源量子云',
  dashboard: 'Dashboard_工作台_本源量子云',
  login: '登录/注册 - 本源量子云',
  register: '注册 - 本源量子云',
  ntpass: '忘记密码 - 本源量子云',
  JupyterTask: 'Jupyter_工作台_本源量子云',
  calculateTask: '计算任务_工作台_本源量子云',
  estimateTask: '价格估算器_工作台_本源量子云',
  application: '应用中心_工作台_本源量子云',
  qPanda: 'QPanda_工作台_本源量子云',
  vqnet: 'VQNET_工作台_本源量子云',
  accessMag: '',
  ide: 'Cloud IDE_工作台_本源量子云',
  pay: '费用中心_工作台_本源量子云',
  resource: '算力资源_工作台_本源量子云',
  expenseCenter: '费用中心_工作台_本源量子云',
  chemiq: '生物化学解决方案_本源量子云',
  finance: '量子金融解决方案_本源量子云',
  educate: '量子计算教育解决方案_本源量子云',
  bigData: '大数据_本源量子云',
  power: '电力行业解决方案_本源量子云',
  ai: '人工智能解决方案_本源量子云',
  engineering: '工程设计解决方案_本源量子云',
  security: '信息安全解决方案_本源量子云',
  hardware: '硬件产品_本源量子云',
  softCenter: '软件中心_本源量子云',
  documentCenter: '文档中心_本源量子云',
  SuperQuantum: '本源悟源_本源量子云',
  userFeedback: '用户反馈_本源量子云',
  workOrder: '提交工单_本源量子云',
  message: '消息中心_本源量子云',
  chemistryIntroduce: 'ChemiQ_本源量子云',
  chemistryTrial: 'ChemiQ试用申请_本源量子云',
  QCFD: '本源量禹_本源量子云',
  copyrightWord:'知识产权声明_本源量子云',
  financeIndex:'量子金融赛道班 | OriginQ Cloud',
  PilotOS: '软件中心_本源量子云',
  activities: '运营活动_本源量子云',

  guide: '新手引导_本源量子云',
  webshh: '命令行_本源量子云',
  OriginRockEncoder:'本源磐石-后量子数据库加密机',
  OriginRockCryptocard:'本源磐石-后量子密码卡',
  OriginRockModule:'本源磐石-后量子软件密码模块',
  verify: '服务号登录/注册 - 本源量子云',
};
export default documentTitle;
